/**
 * Mariner Spirit — hero video, homepage header stack, transparent nav until scroll
 */
(function () {
  var HEADER_STACK_VAR = '--ms-header-stack-height';
  var SCROLL_THRESHOLD = 2;
  var ANNOUNCEMENT_SCROLL_THRESHOLD = 2;

  function playHeroVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function attemptPlay() {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
    }

    if (video.readyState >= 2) {
      attemptPlay();
    } else {
      video.addEventListener('loadeddata', attemptPlay, { once: true });
      video.addEventListener('canplay', attemptPlay, { once: true });
    }

    document.addEventListener(
      'touchstart',
      function retryOnTouch() {
        attemptPlay();
      },
      { once: true, passive: true }
    );
  }

  function syncHeroVideos(hero) {
    var videos = hero.querySelectorAll('.ms-hero-immersion__video');
    if (!videos.length) return;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayDesktop = hero.getAttribute('data-autoplay-desktop') === 'true';
    var autoplayMobile = hero.getAttribute('data-autoplay-mobile') === 'true';
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var shouldPlay = !reduced && (isMobile ? autoplayMobile : autoplayDesktop);

    videos.forEach(function (video) {
      var variant = video.closest('.ms-hero-immersion__media-variant');
      var isActive =
        !variant ||
        (isMobile && variant.classList.contains('ms-hero-immersion__media-variant--mobile')) ||
        (!isMobile && variant.classList.contains('ms-hero-immersion__media-variant--desktop'));

      if (isActive && shouldPlay) {
        playHeroVideo(video);
      } else {
        video.removeAttribute('autoplay');
        video.pause();
      }
    });
  }

  function initHeroVideos(root) {
    var scope = root || document;
    var heroes = scope.querySelectorAll('.ms-hero-immersion[data-ms-hero]');
    heroes.forEach(function (hero) {
      syncHeroVideos(hero);

      if (hero.dataset.msHeroVideosBound === 'true') return;
      hero.dataset.msHeroVideosBound = 'true';

      if (window.matchMedia) {
        var mq = window.matchMedia('(max-width: 749px)');
        if (typeof mq.addEventListener === 'function') {
          mq.addEventListener('change', function () {
            syncHeroVideos(hero);
          });
        } else if (typeof mq.addListener === 'function') {
          mq.addListener(function () {
            syncHeroVideos(hero);
          });
        }
      }
    });
  }

  function getHeaderStackWrap() {
    return document.getElementById('ms-header-stack') || document.querySelector('.ms-header-stack');
  }

  /** Shopify puts .shopify-section-group-header-group on each header *section*, not one wrapper — sum heights if wrap missing (older deploys). */
  function getHeaderStackHeightPx() {
    var wrap = getHeaderStackWrap();
    if (wrap) return wrap.offsetHeight || 0;
    var main = document.getElementById('MainContent');
    if (!main) return 0;
    var total = 0;
    var el = main.previousElementSibling;
    while (el && el instanceof HTMLElement) {
      if (el.tagName === 'CART-DRAWER') {
        el = el.previousElementSibling;
        continue;
      }
      if (
        el.classList &&
        el.classList.contains('shopify-section') &&
        (el.classList.contains('announcement-bar-section') || el.classList.contains('section-header'))
      ) {
        total += el.offsetHeight || 0;
        el = el.previousElementSibling;
        continue;
      }
      break;
    }
    return total;
  }

  function observeHeaderStackResize() {
    var wrap = getHeaderStackWrap();
    if (!wrap || typeof ResizeObserver === 'undefined') return;
    var ro = new ResizeObserver(function () {
      setHeaderStackHeight();
    });
    ro.observe(wrap);
  }

  function setHeaderStackHeight() {
    var h = getHeaderStackHeightPx();
    document.documentElement.style.setProperty(HEADER_STACK_VAR, h + 'px');
  }

  /** Toggle announcement strip with scroll: hidden at top (with transparent hero), shown when scrolled — same thresholds as ms-header-transparent. */
  function updateAnnouncementBarForScrollPosition() {
    if (!document.body.hasAttribute('data-ms-announcement-hide-until-scroll')) return;
    var y = window.scrollY || document.documentElement.scrollTop;
    var scrolled = y > ANNOUNCEMENT_SCROLL_THRESHOLD;
    var revealed = document.body.classList.contains('ms-announcement-revealed');

    if (scrolled && !revealed) {
      document.body.classList.add('ms-announcement-revealed');
      setHeaderStackHeight();
      requestAnimationFrame(setHeaderStackHeight);
    } else if (!scrolled && revealed) {
      document.body.classList.remove('ms-announcement-revealed');
      setHeaderStackHeight();
      requestAnimationFrame(setHeaderStackHeight);
    }
  }

  function initAnnouncementHideUntilScroll() {
    if (!document.body.hasAttribute('data-ms-announcement-hide-until-scroll')) return;

    function onScrollOrResize() {
      updateAnnouncementBarForScrollPosition();
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateAnnouncementBarForScrollPosition();
    setHeaderStackHeight();
    requestAnimationFrame(function () {
      updateAnnouncementBarForScrollPosition();
      setHeaderStackHeight();
    });
  }

  function updateTransparentHeader() {
    if (!document.body.hasAttribute('data-ms-transparent-header')) return;

    var y = window.scrollY || document.documentElement.scrollTop;
    if (y <= SCROLL_THRESHOLD) {
      document.body.classList.add('ms-header-transparent');
    } else {
      document.body.classList.remove('ms-header-transparent');
    }
  }

  function initHeaderStack() {
    setHeaderStackHeight();
    requestAnimationFrame(setHeaderStackHeight);
    observeHeaderStackResize();
    window.addEventListener('resize', setHeaderStackHeight);
    window.addEventListener('load', setHeaderStackHeight);
  }

  function initTransparentNav() {
    var first = document.querySelector(
      '#MainContent > .shopify-section:first-child .ms-hero-immersion--under-nav'
    );
    if (!first) {
      document.body.removeAttribute('data-ms-transparent-header');
      document.body.classList.remove('ms-header-transparent');
      return;
    }

    if (!document.body.hasAttribute('data-ms-transparent-header')) {
      document.body.setAttribute('data-ms-transparent-header', '');
    }

    updateTransparentHeader();

    window.addEventListener('scroll', updateTransparentHeader, { passive: true });
    window.addEventListener('resize', function () {
      setHeaderStackHeight();
      updateTransparentHeader();
    });
  }

  function onReady() {
    initHeroVideos(document);
    initHeaderStack();
    initAnnouncementHideUntilScroll();
    initTransparentNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    initHeroVideos(ev.target);
    setHeaderStackHeight();
    updateTransparentHeader();
    updateAnnouncementBarForScrollPosition();
  });
})();
